export class SmartphotoDocument {
    name;
    url;
    uploadedAt;
    uuid;
    constructor(name, url, uploadedAt, uuid) {
        this.name = name;
        this.url = url;
        this.uploadedAt = uploadedAt;
        this.uuid = uuid;
    }
    getFileName() {
        const [url = ''] = this.url.split('?');
        const [extension] = url.split('.').reverse();
        return `${this.name}.${extension}`;
    }
}
